import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["href", "isAbsolute", "children", "rel"],
  _excluded2 = ["to", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import url from 'url';
import React from 'react';
import NextLink from 'next/link';
import { useGetHrefContext } from '@scentregroup/shared/context';
import { useRouter } from '../next/router';
import { pathRemovingBasePath } from '@scentregroup/shared/lib/path';
import { hrefIsOutsideRouter } from './router';
import { jsx as _jsx } from "react/jsx-runtime";
const isOutbound = (target, current) => {
  const currentUrl = url.parse(current, false);
  const targetUrl = url.parse(target, false, true);
  return Boolean(targetUrl.host && (targetUrl.protocol !== currentUrl.protocol || targetUrl.host !== currentUrl.host || targetUrl.port !== currentUrl.port));
};
const OutboundWrapper = _ref => {
  let {
      href,
      isAbsolute,
      children,
      rel = ''
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const getHref = useGetHrefContext();
  const relParts = rel.split(' ').filter(Boolean);

  // Flag this link as `rel="external"` while also retaining any other `rel=""`
  // attribtues the component might have
  if (isAbsolute && isOutbound(href, getHref()) && !relParts.includes('external')) {
    relParts.unshift('external');
  }
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread(_objectSpread({
    href: href
  }, relParts.length && {
    rel: relParts.join(' ')
  }), props), {}, {
    "data-id": "link_index_OutboundWrapper_a",
    children: children
  }));
};
export const Link = _ref2 => {
  let {
      to,
      children
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const router = useRouter();

  // coerce (string | object) to string
  const href = url.format(to);

  // A route with a schema was passed.  We assume it's an external route so we
  // skip wrapping in the <Link> component
  const isAbsolute = /^[a-zA-Z]+:/.test(href);

  // These links are not handled by our router, we need to trigger a full-page navigation
  const isOutsideRouter = hrefIsOutsideRouter(router.basePath + router.pathname, href);
  if (isAbsolute || isOutsideRouter) {
    return /*#__PURE__*/_jsx(OutboundWrapper, _objectSpread(_objectSpread({}, props), {}, {
      isAbsolute: isAbsolute,
      href: href,
      "data-id": "link_index_OutboundWrapper",
      children: children
    }));
  }
  const hrefWithoutBasePath = pathRemovingBasePath(href, router.basePath);
  return /*#__PURE__*/_jsx(NextLink, {
    legacyBehavior: true,
    href: hrefWithoutBasePath,
    "data-id": "link_index_OutboundWrapper_NextLink",
    children: /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, props), {}, {
      "data-id": "link_index_OutboundWrapper_NextLink_a",
      children: children
    }))
  });
};